import { render, staticRenderFns } from "./FormattedNumberComponent.vue?vue&type=template&id=5ba3540a&"
import script from "./FormattedNumberComponent.vue?vue&type=script&lang=js&"
export * from "./FormattedNumberComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ba3540a')) {
      api.createRecord('5ba3540a', component.options)
    } else {
      api.reload('5ba3540a', component.options)
    }
    module.hot.accept("./FormattedNumberComponent.vue?vue&type=template&id=5ba3540a&", function () {
      api.rerender('5ba3540a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/formatted/FormattedNumberComponent.vue"
export default component.exports